import React, { FC, useCallback, useEffect, useState } from 'react';
import { Button, Divider, Input, Select, SelectProps, Space } from 'antd';
import { useBusinessContext } from '../../context/BusinessContext';
import { useEventListener } from '../../common/EventContext';
import { Vendor } from '../../dto/Vendor';

type Props = Omit<SelectProps<number>, 'options'> & { itemType?: string };

export const ItemSelect: FC<Props> = (props) => {
  const { getSelectValuesAsync } = useBusinessContext();
  const [loading, setLoading] = useState<boolean>(true);
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    getSelectValuesAsync('items')
      .then((options) =>
        setOptions(
          (options as any[]).filter(
            (val) => !props.itemType || val.itemType === props.itemType,
          ),
        ),
      )
      .finally(() => setLoading(false));
  }, [getSelectValuesAsync, props.itemType]);

  return (
    <Select
      {...props}
      loading={loading || props.loading}
      options={options}
      showSearch={true}
      optionFilterProp="label"
      allowClear={true}
    />
  );
};
